// extracted by mini-css-extract-plugin
export var checkIcon = "_f-2";
export var heading = "_f-1";
export var panel = "_f-0";